import UserList from '../container/list/UserList';

function UserListPage() {
  return <UserList />;
}
export default UserListPage;
